import { render } from "./excel-preview.vue?vue&type=template&id=2d563d3b"
import script from "./excel-preview.vue?vue&type=script&lang=js"
export * from "./excel-preview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__